import * as React from 'react'
import PropTypes from 'prop-types'
import NoMachineThankYou from './NoMachineThankYou'
import SnlConfirmation from '../SNLConfirmation/SnlConfirmation.tsx'
import LoadingSpinner from 'components/LoadingSpinner'


const SnlThankYou = ({ formValues, loading, ...pageProps }) => {


  React.useEffect( () => {
    window.scrollTo({
      top: 0,
      behavior: `smooth`
    })
  }, [] )

  if ( formValues.lastOrderCpapMachine === `3` ) return <NoMachineThankYou />

  if ( loading ) return <div className="my-20"><LoadingSpinner /></div>

  return <SnlConfirmation {...pageProps} />
}

SnlThankYou.propTypes = {
  interested: PropTypes.bool,
  loading: PropTypes.bool,
  formValues: PropTypes.shape({
    lastOrderCpapMachine: PropTypes.string
  })
}

export default SnlThankYou
